module.exports = __webpack_public_path__ + "static/media/image.2d553b3d.svg";